import { render, staticRenderFns } from "./SkeletonRecoMobileCard.vue?vue&type=template&id=70425086&"
import script from "./SkeletonRecoMobileCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonRecoMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70425086')) {
      api.createRecord('70425086', component.options)
    } else {
      api.reload('70425086', component.options)
    }
    module.hot.accept("./SkeletonRecoMobileCard.vue?vue&type=template&id=70425086&", function () {
      api.rerender('70425086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SkeletonRecoMobileCard.vue"
export default component.exports